import { PageEvents } from '@griply/types';
import { useTagById } from 'features/tags';
import React from 'react';
import { useParams } from 'react-router';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { CompletedTasks } from './components/completed-tasks';
import { PageTopBar } from './components/page-top-bar';
import { TasksOverview } from './components/tasks-overview';
import * as Styled from './tag.style';

export const TagDetail: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.TagDetail, undefined);
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const tag = useTagById(id);

  if (!tag) {
    return null;
  }

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />
          <Styled.Content ref={scrollContainerRef}>
            <TasksOverview scrollElement={scrollContainerRef} tag={tag} />
            <CompletedTasks />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
